<template>
    <div class="charts charts--outer">
		<div class="charts__row charts__row--row charts__row--wrap">
			<div class="charts__item charts__item--h50" v-for="(item,index) in getLastMonth" :key="index">
				<chart-month
					:datePeriod="new Date(item.year, item.month)"
					@switchMode="switchMode"
					:switchModeIcon="switchIcon[index]"
				>
				</chart-month>
			</div>
		</div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import SingleMonthChart from "./singleMonthChart";
export default {
    components: {
        'chart-month':SingleMonthChart
    },
    props: {
        update:{default:true},
        updateHeight:{default:true},
        updateRight:{default:true},
        fullStatus:{default:false}
    },
    data() {
        return {
            nowDate: new Date(),
            switchIcon:[false, true, false, false]
        }
    },
    computed: {
        ...mapGetters({
            getProfitMonth:'accountstat/getMonthProfitStrategy'
        }),
        getLastMonth() {
            if(this.getProfitMonth('') === null)
                return
            let monthes = this.getProfitMonth('');
            return monthes.slice(-4);
        }
    },
    methods: {
        switchMode() {
            this.$emit('switchMode');
        }
    },
    created() {

    },
}


</script>
<style lang="less" scoped>

</style>
